<template>
    <div class="wizard-step">
        <div class="wizard-step__inner">
            <div class="wizard-step__content">
                <div class="container">
                    <div class="ork-info mb-24" :class="{ 'is-expand': infoExpand }">
                        <header class="ork-info__head">
                            <div class="ork-info__head-inner">
                                <div class="ork-info__head-item">
                                    <input id="standard-status" name="status_document" class="ork-info__textarea" :class="{ 'is-active': mainInfoEditable }" placeholder="Не заполнено" :value="orkInfo.name" @input="e => orkInfoName = e.target.value" :readonly="!mainInfoEditable" />
                                </div>

                                <div v-if="infoExpand" class="ork-info__head-item">
                                    <button v-if="!mainInfoEditable" type="button" class="change-btn" @click="mainInfoEditable = true">
                                        Редактировать

                                        <icon-base viewBox="0 0 18 18" class="change-btn__icon"><icon-edit /></icon-base>    
                                    </button>

                                    <div class="ork-info__head-item-buttons">
                                        <button v-if="mainInfoEditable" type="submit" class="btn btn_success btn_small" @click.prevent="saveNameOrk">
                                            Сохранить

                                            <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon"><icon-save /></icon-base>
                                        </button>

                                        <button v-if="mainInfoEditable" type="button" class="btn btn_danger btn_small" @click.stop.prevent="mainInfoEditable = false">
                                            Отменить

                                            <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon"><icon-cancel /></icon-base>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </header>

                        <div class="ork-info__inner">
                            <div class="ork-info__content">
                                <div class="ork-info__content-item">
                                    <span class="ork-info__label">Разработчик:</span>
                                    <span class="ork-info__value">{{ orkInfo.organisation_name ? orkInfo.organisation_name : '&nbsp;' }}</span>
                                </div>
                                <div class="ork-info__content-item">
                                    <span class="ork-info__label">Состав ОРК:</span>

                                    <span class="ork-info__value">
                                        <ul class="ork-content-list">
                                            <li class="ork-content-list__item">
                                                ОПД: {{ groupQualifications.length }}

                                                <el-tooltip content="Область профессиональной деятельности" placement="bottom-end">
                                                    <icon-base viewBox="0 0 20 20" class="ork-content-list__icon"><icon-faq /></icon-base>
                                                </el-tooltip>
                                            </li>
                                            <li class="ork-content-list__item">
                                                ПС: {{ qualificationLength }}

                                                <el-tooltip content="Профессиональный стандарт" placement="bottom-end">
                                                    <icon-base viewBox="0 0 20 20" class="ork-content-list__icon"><icon-faq /></icon-base>
                                                </el-tooltip>
                                            </li>
                                            <li class="ork-content-list__item">
                                                ПК: {{ standartsLength }}

                                                <el-tooltip content="Профессиональная квалификация" placement="bottom-end">
                                                    <icon-base viewBox="0 0 20 20" class="ork-content-list__icon"><icon-faq /></icon-base>
                                                </el-tooltip>
                                            </li>
                                        </ul>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <button type="button" class="ork-info__toggler" @click="infoExpand = !infoExpand">
                            <icon-base viewBox="0 0 14 8" class="ork-info__arrow"><icon-arrow-down /></icon-base>
                        </button>
                    </div>

                    <accordion v-if="groupKinds.length">
                        <accordion-item highlighted v-for="(groupKind, groupIndex) in groupKinds" :key="groupKind.groupId">
                            <template #accordion-head>
                                <div class="accordion__head" tabindex="0">
                                    <div class="accordion__head-item">
                                        <p class="accordion__title">{{ groupKind.name }}</p>
                                    </div>

                                    <div class="accordion__head-item">
                                        <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                            <icon-arrow-down />
                                        </icon-base>
                                    </div>
                                </div>
                            </template>

                            <el-table
                                cell-class-name="bubble-table__cell"
                                class="bubble-table mt-16"
                                :id="'tableNumber' + groupIndex"
                                header-cell-class-name="table__title"
                                ref="table"
                                row-key="id"
                                :data="groupKind.items"
                            >
                                <el-table-column label="Профессиональный стандарт" fixed width="512">
                                    <el-table-column
                                        label="Жизненный цикл"
                                        prop="lifecycle_id"
                                        min-width="200"
                                    >
                                        <template slot-scope="scope">
                                            <span>{{ getLifecycleById(scope.row.lifecycle_id) }}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Наименование ВПД"
                                        prop="name"
                                        min-width="312"
                                    >
                                        <template slot-scope="scope">
                                            <accordion class="accordion__bubble" :ref="`bubbleAccordionItemId${scope.row.id}`">
                                                <accordion-item>
                                                    <template #accordion-head>
                                                        <div class="accordion__bubble-head" tabindex="0" @click="changeHeightOfRow(scope.row.id, scope.$index, groupIndex)">
                                                            <div class="accordion__head-item">
                                                                <p class="accordion__title">{{ scope.row.name }}</p>
                                                            </div>

                                                            <div class="accordion__head-item">
                                                                <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                                    <icon-arrow-down />
                                                                </icon-base>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <span class="accordion__body-text" @click.prevent.stop="openStandard(scope.row.standard_id, scope.row.id, scope.row.purpose)">{{ scope.row.standard_name }}</span>
                                                </accordion-item>
                                            </accordion>
                                        </template>
                                    </el-table-column>
                                </el-table-column>

                                <el-table-column
                                    :label="`${levelQualification} уровень квалификации`"
                                    min-width="208"
                                    v-for="levelQualification in levelsQualification"
                                    :key="levelQualification"
                                >
                                    <template slot-scope="scope">
                                        <template v-if="getQualificationsByKindIdAndQualificationLevel(scope.row.id, levelQualification).length <= 2">
                                            <span
                                                v-for="(qualificitionBykindId, qualificitionBykindIdIndex) in getQualificationsByKindIdAndQualificationLevel(scope.row.id, levelQualification)"
                                                :key="`${scope.row.id} ${qualificitionBykindIdIndex} ${levelQualification}`"
                                                @click.prevent.stop="openQualification(qualificitionBykindId.id, qualificitionBykindId)"
                                            >
                                                {{ qualificitionBykindId.name }}
                                            </span>
                                        </template>

                                        <accordion v-else class="accordion__bubble accordion__bubble-mini ml-auto mr-auto">
                                            <accordion-item>
                                                <template #accordion-head>
                                                    <div class="accordion__bubble-head accordion__bubble-mini-head" tabindex="0" @click="changeHeightFixedRows(scope.row.id, scope.$index, groupIndex)">
                                                        <div class="accordion__head-item">
                                                            <p class="accordion__title">{{ getQualificationsByKindIdAndQualificationLevel(scope.row.id, levelQualification).length }} ПК</p>
                                                        </div>

                                                        <icon-base class="mt-4" viewBox="0 0 14 8">
                                                            <icon-arrow-down />
                                                        </icon-base>
                                                    </div>
                                                </template>

                                                <span
                                                    v-for="(qualificitionBykindId, qualificitionBykindIdIndex) in getQualificationsByKindIdAndQualificationLevel(scope.row.id, levelQualification)"
                                                    :key="`${scope.row.id} ${qualificitionBykindIdIndex} ${levelQualification}`"
                                                    @click.prevent.stop="openQualification(qualificitionBykindId.id, qualificitionBykindId)"
                                                >
                                                    {{ qualificitionBykindId.name }}
                                                </span>
                                            </accordion-item>
                                        </accordion>
                                        <!-- <div v-else class="accordion__bubble accordion__bubble-mini ml-auto mr-auto">
                                            <div class="accordion__bubble-head accordion__bubble-mini">
                                                <div class="accordion__head-item">
                                                    <p class="accordion__title">{{ getQualificationsByKindIdAndQualificationLevel(scope.row.id, levelQualification).length }} ПК</p>
                                                </div>

                                                <icon-base class="mt-4" viewBox="0 0 14 8">
                                                    <icon-arrow-down />
                                                </icon-base>
                                            </div>
                                        </div> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </accordion-item>
                    </accordion>
                </div>
            </div>
        </div>

        <reference-button v-if="hintsCode && elPanels.standard === 0 && elPanels.qualifications === 0" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />

        <!-- PANELS -->
        <standard-panel
            v-if="activeKindId"
            :kindGoal="activeKindPurpose"
            :kindId="activeKindId"
            :okzsLoader="okzsLoader"
            :okvedsLoader="okvedsLoader"
            :workFunctionsByStandardLoader="workFunctionsByStandardLoader"
            :read="read"
        />

<!--      <qualification-panel-->
<!--          v-if="qualification"-->
<!--          :read="true"-->
<!--          :workFunctionsByQualificationLoader="workFunctionsByQualificationLoader"-->
<!--          :programsByQualificationLoader="programsByQualificationLoader"-->
<!--          :standartLoader="standartLoader"-->
<!--      />-->

<!--        <qualification-panel-->
<!--                             v-if="qualification"-->
<!--                              :read="read"-->
<!--                             :work-functions-by-qualification-loader="workFunctionsByQualificationLoader"-->
<!--                             :programs-by-qualification-loader="programsByQualificationLoader"-->
<!--                             :standart-loader="standartLoader"-->
<!--        />-->
        <all-info-about-qualification-panel
              :read="read"
              v-if="qualification"
              :workFunctionsByQualificationLoader="workFunctionsByQualificationLoader"
              :programsByQualificationLoader="programsByQualificationLoader"
              :standartLoader="standartLoader"
              :hardSkillsByQualificationLoader="hardSkillsByQualificationLoader"
              :softSkillsByQualificationLoader="softSkillsByQualificationLoader"
              :interrelationsByQualificationLoader="interrelationsByQualificationLoader"
          />
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import step from '@/mixins/step';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import AllInfoAboutQualificationPanel from '@/components/WizardPanels/AllInfoAboutQualificationPanel';
import StandardPanel from '@/components/WizardPanels/StandardPanel';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import ReferenceButton from "../ReferenceButton";
import QualificationPanel from "@/components/WizardPanels/QualificationPanel";

export default {
    mixins: [ step ],
    components: {
      QualificationPanel,
        Accordion,
        AccordionItem,
        AllInfoAboutQualificationPanel,
        StandardPanel,
        Tab,
        Tabs,
        ReferenceButton,
    },
    props: {
      read: {
        type: Boolean,
        required: true,
      }
    },
    data() {
        return {
            activeKindId: null,
            activeKindPurpose: null,
            
            okzsLoader: false,
            okvedsLoader: false,
            workFunctionsByStandardLoader: false,
            workFunctionsByQualificationLoader: false,
            programsByQualificationLoader: false,
            standartLoader: false,
            hardSkillsByQualificationLoader: false,
            softSkillsByQualificationLoader: false,
            interrelationsByQualificationLoader: false,

            hasFooter: true,
            hintsCode: 'OrkStep',

            infoExpand: false,
            mainInfoEditable: false,
            searchKindsValue: null,
            selection: {},
            orkInfoName: '',
            levelsQualification: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            openBubble: {},

            groupQualificationsOpts: [
                {
                    name: 'area_id',
                    label: 'По ОПД'
                },
                {
                    name: 'lifecycle_id',
                    label: 'По жизненному циклу'
                }
            ],
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_QUALIFICATION',
            'LOAD_STANDARD',
            'SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION',
            'SILENT_LOAD_OKVEDS',
            'SILENT_LOAD_OKZS',
            'SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD',
            'SILENT_LOAD_STANDARD',
            'SILENT_LOAD_PROGRAMS_BY_QUALIFICATION',
            'SILENT_LOAD_HARD_SKILLS_BY_QUALIFICATION',
            'SILENT_LOAD_SOFT_SKILLS_BY_QUALIFICATION',
            'SILENT_LOAD_INTERRELATIONS_BY_QUALIFICATION',
            'SAVE_ORK_INFO',
        ]),
        ...mapActions('hints', [
            'LOAD_HINTS',
        ]),
        ...mapMutations('common', ['TOGGLE_DIALOG', 'TOGGLE_PANEL']),
        ...mapMutations('editor', ['SET_ITEMS_GROUP']),

      getLifecycleById(lifecycleId) {
          console.log(lifecycleId);
          if (lifecycleId === null) {
            return '';
          }

          return  this.GET_LIFECYCLE_BY_ID(lifecycleId).name;
      },

        changeHeightOfRow(bubbleAccordionItemId, rowIndex, groupIndex) {
            setTimeout(() => {
                const fixedRow = this.$refs[`bubbleAccordionItemId${bubbleAccordionItemId}`][0].$el
                const tableCell = document.getElementById(`tableNumber${groupIndex}`).querySelector('.el-table__body-wrapper').querySelectorAll('.el-table__row')[rowIndex].querySelector('.cell')
                const fixedRowHeight = fixedRow.clientHeight + 2
                
                tableCell.style.height = `${fixedRowHeight}px`
            }, 0);
        },
        changeHeightFixedRows(bubbleAccordionItemId, rowIndex, groupIndex) {
            setTimeout(() => {
                const fixedRow = document.getElementById(`tableNumber${groupIndex}`).querySelector('.el-table__fixed-body-wrapper').querySelectorAll('.el-table__row')[rowIndex].querySelector('.bubble-table__cell')
                const tableCell = document.getElementById(`tableNumber${groupIndex}`).querySelector('.el-table__body-wrapper').querySelectorAll('.el-table__row')[rowIndex].querySelector('.bubble-table__cell')
                const rowHeight = tableCell.clientHeight + 1
                
                fixedRow.style.height = `${rowHeight}px`
            }, 0);
        },

        getQualificationsByKindIdAndQualificationLevel(kindId, qualificationLevel) {
            const tempAr = JSON.parse(JSON.stringify(this.qualifications))

            if (kindId === 0) {
              let empt = tempAr.filter(q => q.standard_id === null);
              return empt.filter(q => q.level === qualificationLevel);
            }
            let arr = tempAr.filter(qualification => qualification.kind_id === kindId && qualification.level === qualificationLevel)
            return arr;
        },

        async openQualification(id, qualification) {
            console.log(id);
            console.log(qualification);

            await this.LOAD_QUALIFICATION(id);

            this.elPanels.qualification = 1;

            this.standartLoader = true
            this.workFunctionsByQualificationLoader = true
            this.programsByQualificationLoader = true
            this.hardSkillsByQualificationLoader = true
            this.softSkillsByQualificationLoader = true
            this.interrelationsByQualificationLoader = true

            if (this.qualification.standard_id) {
              await this.loadStandart(this.qualification.standard_id);
            }

            if (!this.qualification.standard_id) {
              this.standartLoader = false;
            }

            await this.loadWorkFunctionsByQualification(id);
            await this.loadWorkProgramsByQualificationLoader(this.qualification.id);
            await this.loadSoftSkillsByQualification(this.qualification.id);
            await this.loadHardSkillsByQualification(this.qualification.id);
            await this.loadInterrelationsByQualification(this.qualification.id);
        },

        async openStandard(id, kindId, kindPurpose) {
            if (id) await this.LOAD_STANDARD(id)
            else this.SET_STANDARD({})


            this.activeKindId = kindId;
            this.activeKindPurpose = kindPurpose;


            this.elPanels.standard = 1;
            this.elPanels.qualifications = 0;

            if (id) {
                this.okzsLoader = true
                this.okvedsLoader = true
                this.workFunctionsByStandardLoader = true

                await this.loadOkzs()
                await this.loadOkveds()
                await this.loadWorkFunctionsByStandard(id)
            }
        },

        saveNameOrk() {
            const id = this.orkInfo.id
            const params = { name: this.orkInfoName }
            this.SAVE_ORK_INFO({
                id,
                params
            })
            this.mainInfoEditable = false
        },

        async loadOkzs() {
            await this.SILENT_LOAD_OKZS(),
            this.okzsLoader = false
        },
        async loadOkveds() {
            await this.SILENT_LOAD_OKVEDS(),
            this.okvedsLoader = false
        },
        async loadWorkFunctionsByStandard(id) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_STANDARD(id)
            this.workFunctionsByStandardLoader = false
        },
        async loadWorkFunctionsByQualification(id) {
            await this.SILENT_LOAD_WORK_FUNCTIONS_BY_QUALIFICATION(id),
            this.workFunctionsByQualificationLoader = false
        },
        async loadWorkProgramsByQualificationLoader(id) {
            await this.SILENT_LOAD_PROGRAMS_BY_QUALIFICATION(id),
            this.programsByQualificationLoader = false
        },
        async loadStandart(id) {
            await this.SILENT_LOAD_STANDARD(id),
            this.standartLoader = false
        },
        async loadHardSkillsByQualification(id) {
            await this.SILENT_LOAD_HARD_SKILLS_BY_QUALIFICATION(id),
            this.hardSkillsByQualificationLoader = false
        },
        async loadSoftSkillsByQualification(id) {
            await this.SILENT_LOAD_SOFT_SKILLS_BY_QUALIFICATION(id),
            this.softSkillsByQualificationLoader = false
        },
        async loadInterrelationsByQualification(id) {
            await this.SILENT_LOAD_INTERRELATIONS_BY_QUALIFICATION(id)
            this.interrelationsByQualificationLoader = false
        },
    },
    computed: {
        ...mapGetters('editor', ['GET_LIFECYCLE_BY_ID']),
        ...mapState('common', ['dialogs', 'panels']),
        ...mapState('editor', ['groupQualifications', 'groupKinds', 'kinds', 'qualifications', 'qualification', 'orkInfo']),
        ...mapState('hints', ['hints']),

        qualificationLength() {
            return this.kinds.filter(el => el.standard_id !== null).length
        },
        standartsLength() {
            return this.qualifications.length
        }
    },

    async created() {
        this.STATUSES_DICT = constants.STATUSES_DICT;
    }
}
</script>
